import { makeStyles } from "@material-ui/core";
import { common } from "@material-ui/core/colors";

const useMainScreenStyles = makeStyles(({ palette: { custom } }) => ({
  root: {
    boxSizing: "border-box",
    display: "grid",
    gridTemplateRows: "52px 1fr",
    position: "fixed",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: custom.high,
  },
  header: {
    gridRow: "1 / 2",
    position: "relative",
    zIndex: 3,
    borderBottom: `1px solid ${custom.border[200]}`,
  },
  content: {
    gridRow: "2 / 3",
    position: "relative",
    zIndex: 1,
  },
  contentHeaderless: {
    gridRow: "1 / 3",
  },
  rootLarge: {
    gridTemplateColumns: "72px 1fr",
  },
  headerLarge: {
    gridColumn: "1 / 3",
    gridRow: "1 / 2",
  },
  menu: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    width: 280,
    paddingTop: 0,
    backgroundColor: custom.bg[300],
    transform: "translate(-280px)",
    transition: "transform 150ms",
    zIndex: 4,
  },
  menuOpen: {
    transform: "translate(0px)",
  },
  menuOverlay: {
    display: "none",
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: common.black,
    opacity: 0.6,
    zIndex: 3,
    border: 0,
    "& > button": {
      width: "100%",
      height: "100%",
      opacity: 0,
    },
  },
  menuOverlayOpen: {
    display: "block",
  },
  menuLarge: {
    gridColumn: "1 / 2",
    gridRow: "2 / 3",
    position: "relative",
    left: 0,
    zIndex: 2,
    borderRight: `1px solid ${custom.border[200]}`,
  },
  contentLarge: {
    gridColumn: "2 / 3",
    gridRow: "2 / 3",
  },
}));

export default useMainScreenStyles;
